import { HeaderFooterLayout } from '../app';
import HeroHeaderSection from './HeroHeaderSection';
import RootContainer from './RootContainer';
// import ProHeroMobileImage from './images/pro-hero-mobile.png';
// import ProHeroDesktopImage from './images/pro-hero-desktop.png';
import HorizontalFeatureSection from './HorizontalFeatureSection';
import TestimonialSection from './TestimonialSection';
import ProTestimonialAvatar1Svg from './images/pro-testimonial-avatar1.svg';
import ProTestimonialAvatar2Svg from './images/pro-testimonial-avatar2.svg';
import SquareFeaturePanel from './SquareFeaturePanel';
// import ProIsThisForMeImage from './images/pro-isthisforme-image.png';
// import ProWhatYoullGainImage from './images/pro-whatyoullgain-image.png';
// import ProContactCollage from './images/pro-contact-collage.png';
import CTACard from './CTACard';
import VerticalFeaturePanel from './VerticalFeaturePanel';
import TestimonialCardsSection from './TestimonialCardsSection';
import MetricsSection from './MetricsSection';
import TestimonialMapSection from './TestimonialMapSection';
import SignUpSection from './SignUpSection';
import FAQSection from './FAQSection';
import MetaTags from '../util/MetaTags';

const ProHeroMobileImage =
  'https://movingworldspublic.blob.core.windows.net/public/landing/pro/pro-hero-mobile.webp';
const ProHeroDesktopImage =
  'https://movingworldspublic.blob.core.windows.net/public/landing/pro/pro-hero-desktop.webp';
const ProIsThisForMeImage =
  'https://movingworldspublic.blob.core.windows.net/public/landing/pro/pro-isthisforme-image.webp';
const ProWhatYoullGainImage =
  'https://movingworldspublic.blob.core.windows.net/public/landing/pro/pro-whatyoullgain-image.webp';
const ProContactCollage =
  'https://movingworldspublic.blob.core.windows.net/public/landing/pro/pro-contact-collage.webp';

const ProfessionalsPage = () => {
  return (
    <HeaderFooterLayout>
      <MetaTags
        title='Create change with skills-based volunteering projects | MovingWorlds.org'
        description='Find meaningful skills-based volunteering projects that are good for the world and your career.'
        imageUrl={ProHeroMobileImage}
      />
      <RootContainer>
        <HeroHeaderSection
          title='Create Change. Be Changed. | MovingWorlds.org'
          description='Find meaningful skills-based volunteering projects that are good for the world and your career.'
          mobileImage={ProHeroMobileImage}
          desktopImage={ProHeroDesktopImage}
          useDesktopImagePadding
        />
      </RootContainer>
      <HorizontalFeatureSection
        header='How it Works'
        items={[
          {
            icon: 'file-check-02',
            title: 'Tell us your skills & goals',
            subtitle:
              "Tell us what you're good at and what you care about, and we'll match you with a project that fits.",
          },
          {
            icon: 'zap',
            title: 'Get matched',
            subtitle:
              'Work with an organization that aligns with your skills, schedule, and purpose.',
          },
          {
            icon: 'chart-breakout-square',
            title: 'Support a social enterprise',
            subtitle:
              'Make a real impact—and return with new skills, confidence, and a story to share.',
          },
        ]}
      />
      <TestimonialSection
        isDesktopLarge
        quote="Funny enough, the basic skills I use every day turned out to be the most helpful. I expected the complex stuff to matter more—but I was wrong. Collaborating with a social entrepreneur was energizing. We kept building on each other's ideas."
        name='Beatriz Scabelli'
        title='Senior User Experience Designer, SAP'
        avatarSrc={ProTestimonialAvatar1Svg}
      />
      <SquareFeaturePanel
        title='Is this right for me?'
        description="You don't need social impact experience. You're a great fit if you have:"
        items={[
          {
            title: 'Real-world experience',
            description:
              'At least 3 years solving business challenges in your field—whether in strategy, marketing, finance, HR, or beyond.',
          },
          {
            title: 'Transferable skills',
            description:
              'Your everyday strengths—like project management, strategy, or systems thinking—are exactly what social enterprises need to grow.',
          },
          {
            title: 'An open and curious mind',
            description:
              "You don't need global experience—just curiosity, collaboration, and a willingness to apply your skills in new ways.",
          },
          {
            title: 'A desire to grow ',
            description:
              "It's about your mindset, not your title. We'll support you with guidance, tools, and a global community.",
          },
        ]}
        mobileImage={ProIsThisForMeImage}
        desktopImage={ProIsThisForMeImage}
      />
      <CTACard
        title='Join today'
        description="We'll help you match your skills to real needs—and scope a project that fits your schedule."
      />
      <VerticalFeaturePanel
        title="What you'll gain"
        items={[
          'Real-world experience that builds your skills—and your resume',
          'Confidence to lead in new settings and stretch your potential',
          'A sense of purpose and connections to people solving real problems around the world',
          'Exposure to new industries, regions, and business models',
        ]}
        image={ProWhatYoullGainImage}
      />
      <TestimonialSection
        quote='This journey grounded me and broadened my perspective, making me a better consultant and a more empathetic professional.'
        name='Sheikh Sohail Amir'
        title='Revenue Operations Specialist, F5'
        avatarSrc={ProTestimonialAvatar2Svg}
      />
      <TestimonialCardsSection
        title='Real Projects. Real Professionals. Real Impact.'
        description='From building go-to-market strategies to improving financial systems and digital presence, see how professionals like you have helped social enterprises grow.'
      />
      <MetricsSection
        title='By the numbers'
        description='Your skills can go farther than you think.'
        items={[
          {
            numberText: '96%',
            headline: 'Professionals grew as leaders',
            description: 'Volunteering built leadership skills and boosted confidence.',
          },
          {
            numberText: '110',
            headline: 'Countries reached',
            description: 'Projects delivered across a diverse, global network of changemakers.',
          },
          {
            numberText: '2,500',
            headline: 'Successful matches',
            description: 'Tailored collaborations that create tangible results.',
          },
          {
            numberText: '82%',
            headline: 'Organizations upskilled',
            description: "Direct collaboration boosted organizations' skills and capacity.",
          },
        ]}
      />
      <TestimonialMapSection />
      <SignUpSection
        title='Ready to to grow your career—and your impact?'
        description="We'll help you find a meaningful project that matches your skills, fits your schedule, and makes a real difference."
        image={ProContactCollage}
      />
      <FAQSection
        items={[
          {
            question: 'What kinds of organizations would I be supporting?',
            answer: (
              <p>
                You'll collaborate with community-led social enterprises, nonprofits, and other
                mission-driven organizations with proven solutions that create real impact — from
                climate action to inclusive economic growth. Every organization on our platform is
                vetted and verified to be advancing meaningful change, and you'll get to review
                their mission, goals, and needs before committing to a project that aligns with your
                interests.
              </p>
            ),
          },
          {
            question: "What if I've never volunteered before?",
            answer: (
              <p>
                That's just fine! You don't need prior experience as a volunteer to make a
                difference. What matters is your ability to think strategically, solve problems, and
                collaborate across teams. That's exactly what social enterprises need - and we'll
                guide you every step of the way.
              </p>
            ),
          },
          {
            question: 'How will I be supported throughout the process? ',
            answer: (
              <p>
                You're already taking a courageous step by stretching beyond your comfort zone—and
                we're here to back you up every step of the way. We offer tools, guides, templates,
                and recorded trainings to help you prepare. You'll also have access to live events
                and a community of professionals doing the same. Our team will check in with you
                throughout the process - and are always just an email away if you need 1:1 support
                or assistance.
              </p>
            ),
          },
          {
            question: 'How much time do I need to commit? ',
            answer: (
              <p>
                It depends on the type of project and how you're joining. Most projects require just
                a few hours a week over 2-3 months, but some are full-time sprints. If you're
                joining through your employer, they'll guide your time commitment—some offer 10%
                time over several months, others sponsor 1-2 weeks full-time. Whatever your
                schedule, we'll help match you to a project that fits.
              </p>
            ),
          },
        ]}
      />
    </HeaderFooterLayout>
  );
};

export default ProfessionalsPage;
